<template>
  <div class='detail' @click.stop='showDetail(job.id)'>
    <div class='top'>
      <p class='header'>{{job.title}}</p>
      <div class="dis">
        <p class='descripe'>
          <!-- <span class='salary'>{{job.salary | salaryFilter}}</span> -->
          <span class='prop'>{{job.education | educationFilter}}</span>
          <span class='line'>&nbsp;</span>
          <span class='prop'>{{job.yearOfWorking | jobExperiencesFilter}}</span>
        </p>
        <p class="moeny">{{job.salary | salaryFilter}}</p>
      </div>
      <p class='number same'><i class='iconfont icon-renshu'></i><span>招聘{{job.number}}人</span></p>
      <p class='jobstatus same'><i class='iconfont icon-zhiwei'></i><span>{{job.jobType | jobTypeFilter}}</span></p>
    </div>
    <p class='footer'><span class='left'>{{job.corpName}}</span><span class='right'>{{job.createTime | DateFilter}}</span></p>
  </div> 
</template>

<script>
export default {
  props: {
    job: {
      type: Object,
      default() {
        return {
          id: 'job001', 
          type: 0, 
          key: 1, 
          position: '运营采购经理', 
          salary: '12000' , 
          date: '2017-10-24', 
          descripe: '本科及以上 | 8年以上 | 全职| 招聘5人', 
          company: '深圳市天宇微盟电子仪器有限公司', 
        };
      },
    },
  },
  methods: {
    showDetail(id) {
      this.$router.push({ path: `/humanResource/jobDetail/${id}`, query:this.$route.query });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@scss';
.dis{
  display: flex;
  justify-content: space-between;
  .moeny{
    color: #288ff8;
    font-size: .58rem;
  }
}
.detail{
  margin-bottom: 12px;
  // border: 1px solid #c4c4c4;
  .top{
    padding: .4rem;
    background: #ffffff;
    .header{
      line-height: .746667rem;
      font-weight: 600;
      // font-size: .453333rem;
      color: rgb(51, 51, 51);
    }
    .descripe{
      font-weight: 600;
      .salary{
        margin-right: .16rem;
        color: $color-main;
        font-size: .4rem;
      }
      .prop{
        color: rgb(51, 51, 51);
        font-size: .266667rem
      }
      .line{
        display: inline-block;
        border-right: 1px solid rgb(51, 51, 51);
        line-height: .266667rem;
        vertical-align: middle;
      }
    }
    .same{
      line-height: .64rem;
      font-size: .32rem;
      color: rgb(51, 51, 51);
      .iconfont{
        color: rgb(153, 153, 153);
        font-size: .32rem;
      }
    }
  }
  .footer{
    @include clear-float;
    padding: .4rem;
    background: #fff;
    font-size: .306667rem;
    color: #666666;
    .left, .right{
      display: inline-block;
      vertical-align: middle;
    }
    .left {
      float: left;
    }
    .right{
      float: right;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/humanResource/components/JobItem.vue